jQuery(document).ready(function() {
    $("#help-dialog-form").dialog({
        autoOpen: false,
        height: 550,
        width: 500,
        modal: true,
        close: function () {
        }
    });

    $( "#help-dialog-message" ).dialog({
        autoOpen: false,
        modal: false,
        buttons: { },
        position: { my: "right top", at: "right top", of: "body" }
    });
});
